<div class="container course-detail">
    <div class="box-default3 w-100 shadow-lg">
      <h4>Multidisciplinary Courses</h4>
        <img src="assets/img/course/MDC.PNG" alt="MDC Image" class="img-fluid">
    </div>
</div>